// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"759":"2241c067","966":"c4d2d38c"}[chunkId] + ".css";
};